import React from 'react';
import { Inscription } from '@common-fe/common-fe';

import { WarnModal } from '@/components/elements';
interface Props {
  lockingLeft?: number;   
  onSetVisible: (value: boolean) => void;
}

const AccountLockoutModal: React.FC<Props> = ({ lockingLeft, onSetVisible }) => {
  return (
    <WarnModal
      visible
      onSetVisible={onSetVisible}
      header="Account Locked"
    >
      <Inscription margin={{ top: 'spacing12' }}>
        Your account has been locked due to failed login attempts. You can try again in {lockingLeft} minutes.
      </Inscription>
    </WarnModal>
  );
};

export default AccountLockoutModal;
